import { render } from "./IncidentsToday.vue?vue&type=template&id=2adef3d4"
import script from "./IncidentsToday.vue?vue&type=script&lang=js"
export * from "./IncidentsToday.vue?vue&type=script&lang=js"

import "./IncidentsToday.vue?vue&type=style&index=0&id=2adef3d4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__